import { createSlice } from '@reduxjs/toolkit';
import { LOAD_STATES } from '../constants';
const {
  UNLOADED,
  LOADED
} = LOAD_STATES;
const initialState = {
  loadState: UNLOADED
};
const suiteContextSlice = createSlice({
  name: 'suite',
  initialState,
  reducers: {
    updateSuiteContext: (state, action) => ({ ...state,
      ...action.payload,
      loadState: LOADED
    })
  }
});
export const {
  updateSuiteContext
} = suiteContextSlice.actions;
export default suiteContextSlice;
//# sourceMappingURL=suite-context-slice.js.map